export default __webpack_public_path__ + "static/media/ventrilla5.24ec3bae.jpg";